export default [
    {
        path: 'aviso',
        component: () => import(
            /* webpackChunkName: 'painel-senha-aviso' */
            '@/views/painel-senha/aviso/Index'
        ),
        redirect: 'aviso/index',
        children: [
            {
                name: 'painel-senha-aviso-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'painel-senha-aviso-index' */
                    '@/views/painel-senha/aviso/List.vue'
                ),
            },
            {
                name: 'painel-senha-aviso-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'painel-senha-aviso-create' */
                    '@/views/painel-senha/aviso/Form.vue'
                ),
            },
            {
                name: 'painel-senha-aviso-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'painel-senha-aviso-edit' */
                    '@/views/painel-senha/aviso/Form.vue'
                ),
            },
        ],
    },
]